import React from "react";
import "../../Assets/SCSS/components/Thumbnail.scss";
import DefaultProfileImage from "Assets/Images/profile_defaultImg.svg";

const ProfilePicture = ({ src, height, classname }) => (
  <img
    className={`profile-picture-custom ${classname}`}
    src={src ? src : DefaultProfileImage}
    height={height}
  ></img>
);

export default ProfilePicture;
